import React from "react"
import { createPortal } from "react-dom"
import { X } from "lucide-react"
import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
    return twMerge(clsx(inputs))
}

const Dialog = ({ open, onOpenChange, children }) => {
    if (!open) return null;

    return createPortal(
        <div className="fixed inset-0 z-[100] flex items-center justify-center">
            {/* Backdrop */}
            <div
                className="fixed inset-0 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0"
                onClick={() => onOpenChange(false)}
            />
            {/* Content Wrapper to ensure z-index separation if needed, or just children */}
            <div className="relative z-[101] w-full max-w-lg">
                {children}
            </div>
        </div>,
        document.body
    )
}

const DialogContent = ({ className, children, ...props }) => {
    return (
        <div
            className={cn(
                "grid w-full gap-4 p-6 duration-200 sm:rounded-2xl glass",
                "animate-in fade-in-0 zoom-in-95 slide-in-from-bottom-10 sm:slide-in-from-bottom-0",
                className
            )}
            {...props}
        >
            {children}
        </div>
    )
}

const DialogHeader = ({ className, children, ...props }) => {
    return (
        <div
            className={cn("flex flex-col space-y-1.5 text-center sm:text-left", className)}
            {...props}
        >
            {children}
        </div>
    )
}

const DialogTitle = ({ className, children, ...props }) => {
    return (
        <h2
            className={cn("text-lg font-semibold leading-none tracking-tight text-foreground", className)}
            {...props}
        >
            {children}
        </h2>
    )
}

const DialogFooter = ({ className, children, ...props }) => {
    return (
        <div
            className={cn("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className)}
            {...props}
        >
            {children}
        </div>
    )
}

const DialogDescription = ({ className, children, ...props }) => {
    return (
        <p
            className={cn("text-sm text-muted-foreground", className)}
            {...props}
        >
            {children}
        </p>
    )
}

export { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter }
